
@switch (type) {
  @case ('default') {
    @for (item of chartData; track item; let last = $last) {
      <h2>{{ item.graphTitle | titleCase }}</h2>
      <google-chart [data]="item"></google-chart>
      @if (item.graphSource) {
        <i class="graph__source">
          {{ 'oska.graph_source' | translate }}: {{ item.graphSource | titleCase }}
        </i>
      }
      @if (!last) {
        <hr aria-hidden="true">
      }
    }
  }
  @case ('filter') {
    @for (item of data; track item; let last = $last) {
      <h3>{{ item.graphTitle | titleCase }}</h3>
      <div class="graph__text" [innerHTML]="item.graphText"></div>
      @if (item && item.filters) {
        <div class="formItems" [ngClass]="{'formItems--3': wide, 'formItems--2': !wide}">
          @for (select of item.filters; track select; let i = $index) {
            @if (select.options.length > 1) {
              <div>
                @if (select.multiple && filters[item.id]) {
                  <formItem
                    type="multi-select"
                    (onChange)="getGraphData(item.id)"
                    [(ngModel)]="filters[item.id][select.key]"
                    [title]="select.key"
                    [testId]="'chart-filters-select-' + select.key"
                    [options]="select.options">
                  </formItem>
                }
                @if (!select.multiple && filters[item.id]) {
                  <formItem
                    (onChange)="getGraphData(item.id)"
                    type="select"
                    [(ngModel)]="filters[item.id][select.key]"
                    [title]="select.key"
                    [testId]="'chart-filters-select-' + select.key"
                    [options]="select.options">
                  </formItem>
                }
              </div>
              }<!--/col-->
            }
          </div><!--/row-->
          <div class="chart-wrapper" [class.chart-wrapper--shorter__bottom]="item.graphSource">
            @if (filtersData[item.id]) {
              @if (filtersData[item.id].loading) {
                <div class="chart-wrapper__loader">
                  <loader></loader>
                </div>
                }<!--/chart-wrapper__loader-->
                @if (filtersData[item.id].dataTable && !filtersData[item.id].loading) {
                  <google-chart
                    [data]="filtersData[item.id]"
                  ></google-chart>
                }
              }
            </div><!--/chart-wrapper-->
          }
          @if (item.graphSource) {
            <i class="graph__source">
              {{ 'oska.graph_source' | translate }}: {{ item.graphSource | titleCase }}
            </i>
          }
          @if (!last) {
            <hr aria-hidden="true">
          }
        }
      }
    }
